export const mockWorkOrderDetails = [
	{
		id: 4471,
		code: "WO20260818_L174FD",
		vehicleId: 1401,
		plateNumber: "SMS1000Z",
		// InWorkshop — the starting state completeWorkshopWorkOrder requires.
		status: "InWorkshop",
		allowedTransitions: ["CompletedByWorkshop", "Cancelled"],
		flowType: "Workshop",
		createdAt: "2026-08-18T05:38:00Z",
		lastUpdatedAt: "2026-09-01T00:00:00Z",
		destination: {
			type: "Workshop",
			workshopId: 12,
			workshopName: "Workshop ABC",
			address: "6 Ubi Ave #01-100 Singapore 432123",
		},
		appointmentStart: "2026-08-20T01:00:00Z",
		appointmentEnd: "2026-08-20T05:00:00Z",
		workshopEnteredAt: "2026-08-20T01:12:00Z",
		workshopCompletedAt: null,
		issues: [
			{
				id: 2,
				code: "IS20260731_BXJ46C",
				serviceCategory: "Bodywork",
				issueType: {
					id: 1,
					name: "Front bumper",
				},
				issueDescription:
					"Front bumper broken due collision with pillar",
				createdAt: "2026-07-31T02:14:00Z",
				status: "InProgress",
				allowedTransitions: ["Completed", "Cancelled"],
				outcome: null,
				unfixedReason: null,
				zendeskId: "482910",
				relatedCaseNo: "CASE20260928_HTQKJ0",
				handoverFlagged: false,
				handoverNote: null,
			},
			{
				id: 5,
				code: "IS20260731_BXJ66C",
				serviceCategory: "Maintenance",
				issueType: {
					id: 2,
					name: "Left headlight",
				},
				issueDescription: "Headlight bulb wiring",
				createdAt: "2026-07-31T02:20:00Z",
				status: "InProgress",
				allowedTransitions: ["Completed", "Cancelled"],
				outcome: null,
				unfixedReason: null,
				zendeskId: null,
				relatedCaseNo: null,
				handoverFlagged: false,
				handoverNote: null,
			},
			{
				id: 15,
				code: "IS20260731_BXJ99E",
				serviceCategory: "Maintenance",
				issueType: {
					id: 9,
					name: "Tyres",
				},
				issueDescription: "Worn rear tyres need replacing",
				createdAt: "2026-07-31T02:30:00Z",
				status: "InProgress",
				allowedTransitions: ["Completed", "Cancelled"],
				outcome: null,
				unfixedReason: null,
				zendeskId: null,
				relatedCaseNo: null,
				handoverFlagged: false,
				handoverNote: null,
			},
		],
		jobs: [
			{
				jobId: 430219,
				code: "J20260731_6RH8FG",
				status: "completed",
				allowedTransitions: [],
				priority: "high",
				start: "2026-07-31T00:00:00Z",
				due: "2026-07-31T02:00:00Z",
				assignedTo: {
					type: "User",
					id: "samlim@getgo.sg",
					display: "Sam Lim",
				},
				createdBy: "johnsmith@getgo.sg",
				taskCount: 1,
				tasks: [
					{
						taskId: 944307,
						taskPresetId: 7,
						code: "TK20260731_6RH8FA",
						name: "Home lot to Workshop",
						plannerRemarks: "Tow to Workshop ABC",
						priority: "high",
						status: "completed",
						media: [
							{
								url: "https://picsum.photos/seed/task944307-1/600/400",
								type: "Photo",
								caption: "Vehicle on tow truck",
							},
							{
								url: "https://picsum.photos/seed/task944307-2/600/400",
								type: "Photo",
								caption: "Loaded onto flatbed",
							},
						],
					},
				],
			},
			{
				jobId: 430220,
				code: "J20260731_8GH4UF",
				status: "assigned",
				allowedTransitions: ["ongoing", "cancelled"],
				priority: "high",
				start: "2026-09-02T00:00:00Z",
				due: "2026-09-02T02:00:00Z",
				assignedTo: {
					type: "Group",
					id: "ops-north",
					display: "Ops North",
				},
				createdBy: "opsmgr@getgo.sg",
				taskCount: 1,
				tasks: [
					{
						taskId: 944308,
						taskPresetId: 9,
						code: "TK20260902_8GH4UA",
						name: "Workshop to Home lot",
						plannerRemarks: "Tow to homelot",
						priority: "high",
						status: "assigned",
						media: [],
					},
				],
			},
			{
				jobId: 430221,
				code: "J20260731_9JK2LM",
				status: "cancelled",
				allowedTransitions: [],
				cancelReasonCode: "WronglyCreated",
				cancelNotes: "Job was created against the wrong vehicle.",
				priority: "medium",
				start: "2026-08-01T00:00:00Z",
				due: "2026-08-01T02:00:00Z",
				assignedTo: {
					type: "User",
					id: "amirah.rahman@getgo.sg",
					display: "Amirah Rahman",
				},
				createdBy: "opsmgr@getgo.sg",
				taskCount: 1,
				tasks: [
					{
						taskId: 944309,
						taskPresetId: 7,
						code: "TK20260801_9JK2LA",
						name: "Home lot to Workshop",
						plannerRemarks: "Cancelled before pickup",
						priority: "medium",
						status: "cancelled",
						media: [],
					},
				],
			},
			{
				jobId: 430222,
				code: "J20260801_4RT7BC",
				status: "ongoing",
				allowedTransitions: ["paused", "completed", "cancelled"],
				priority: "high",
				start: "2026-08-05T00:00:00Z",
				due: "2026-08-05T02:00:00Z",
				assignedTo: {
					type: "User",
					id: "johnsmith@getgo.sg",
					display: "John Smith",
				},
				createdBy: "opsmgr@getgo.sg",
				taskCount: 1,
				tasks: [
					{
						taskId: 944310,
						taskPresetId: 7,
						code: "TK20260805_4RT7BA",
						name: "Workshop to Home lot",
						plannerRemarks: "In progress — not yet cancelled",
						priority: "high",
						status: "ongoing",
						media: [],
					},
				],
			},
		],
	},

	{
		id: 4472,
		code: "WO20260818_L17F4E",
		vehicleId: 1401,
		plateNumber: "SMS1000Z",
		status: "Triage",
		allowedTransitions: ["Cancelled", "InWorkshop"],
		flowType: "Workshop",
		createdAt: "2026-08-17T02:15:00Z",
		lastUpdatedAt: "2026-08-21T09:05:00Z",
		destination: null,
		appointmentStart: null,
		appointmentEnd: null,
		workshopEnteredAt: null,
		workshopCompletedAt: null,
		issues: [],
		jobs: [],
	},

	// NonWorkshop flow — completion runs automatically (no manual "Completed"
	// transition allowed) and there's no destination/workshop, so
	// MarkAsCompletedModal hides the vehicle-active choice and
	// updateWorkOrderStatusTransition rejects targetState: "Completed" with
	// 409/29202 for this one regardless of currentState. allowedTransitions
	// omits "Completed" to match — the real backend would never advertise a
	// transition it always rejects.
	{
		id: 4475,
		code: "WO20260825_QK92LM",
		vehicleId: 1401,
		plateNumber: "SMS1000Z",
		status: "InProgress",
		allowedTransitions: ["Cancelled"],
		flowType: "NonWorkshop",
		createdAt: "2026-08-20T03:00:00Z",
		lastUpdatedAt: "2026-08-20T03:00:00Z",
		destination: null,
		appointmentStart: null,
		appointmentEnd: null,
		workshopEnteredAt: null,
		workshopCompletedAt: null,
		issues: [
			{
				id: 9,
				code: "IS20260820_NW4471",
				serviceCategory: "Non-workshop",
				issueType: {
					id: 7,
					name: "Esso card missing",
				},
				issueDescription: "Esso card missing",
				createdAt: "2026-08-20T03:00:00Z",
				status: "InProgress",
				allowedTransitions: ["Completed", "Cancelled"],
				outcome: null,
				unfixedReason: null,
				zendeskId: null,
				relatedCaseNo: null,
				handoverFlagged: false,
				handoverNote: null,
			},
		],
		jobs: [],
	},

	// mockWorkOrders.ts's vehicle-1402 list (WO20260818_L17F4F) has no
	// matching detail record here — without it, opening this work order
	// from the list renders "Work order not found", and it 404s as an
	// "add to existing work order" move target.
	{
		id: 4473,
		code: "WO20260818_L17F4F",
		vehicleId: 1402,
		plateNumber: "SRT5641A",
		status: "Triage",
		allowedTransitions: ["Cancelled"],
		flowType: "NonWorkshop",
		createdAt: "2026-08-19T11:50:00Z",
		lastUpdatedAt: "2026-08-19T11:50:00Z",
		destination: null,
		appointmentStart: null,
		appointmentEnd: null,
		workshopEnteredAt: null,
		workshopCompletedAt: null,
		issues: [
			{
				id: 3,
				code: "IS20260713_LXJ86H",
				serviceCategory: "Non-workshop",
				issueType: {
					id: 6,
					name: "Pest infestation",
				},
				issueDescription: "2 nymphs found",
				createdAt: "2026-07-13T08:00:00Z",
				status: "Assigned",
				allowedTransitions: [],
				outcome: null,
				unfixedReason: null,
				zendeskId: "591204",
				relatedCaseNo: "CASE20260722_G39MB4",
				handoverFlagged: false,
				handoverNote: null,
			},
		],
		jobs: [],
	},

	// Same gap as WO20260818_L17F4F above, for vehicle 1402's other listed
	// work order (WO20260818_L17F4G).
	{
		id: 4474,
		code: "WO20260818_L17F4G",
		vehicleId: 1402,
		plateNumber: "SRT5641A",
		status: "Triage",
		allowedTransitions: ["Cancelled"],
		flowType: "NonWorkshop",
		createdAt: "2026-08-16T14:22:00Z",
		lastUpdatedAt: "2026-08-22T17:40:00Z",
		destination: null,
		appointmentStart: null,
		appointmentEnd: null,
		workshopEnteredAt: null,
		workshopCompletedAt: null,
		issues: [
			{
				id: 4,
				code: "IS20260705_PXN81C",
				serviceCategory: "Non-workshop",
				issueType: {
					id: 7,
					name: "Esso card missing",
				},
				issueDescription: "Esso card missing",
				createdAt: "2026-07-05T08:00:00Z",
				status: "Backlog",
				allowedTransitions: [],
				outcome: null,
				unfixedReason: null,
				zendeskId: null,
				relatedCaseNo: null,
				handoverFlagged: false,
				handoverNote: null,
			},
		],
		jobs: [],
	},

	// Listed in mockWorkshopWorkOrders.ts — needs a matching detail record
	// here too, or opening it renders "Work order not found."
	{
		id: 4468,
		code: "WO20260725_A912BC",
		vehicleId: 1402,
		plateNumber: "SRT5641A",
		status: "InWorkshop",
		allowedTransitions: ["CompletedByWorkshop", "Cancelled"],
		flowType: "Workshop",
		createdAt: "2026-07-20T02:00:00Z",
		lastUpdatedAt: "2026-07-25T15:00:00Z",
		destination: {
			type: "Workshop",
			workshopId: 12,
			workshopName: "Workshop ABC",
			address: "6 Ubi Ave #01-100 Singapore 432123",
		},
		appointmentStart: "2026-07-22T02:00:00Z",
		appointmentEnd: "2026-07-22T06:00:00Z",
		workshopEnteredAt: "2026-07-20T02:00:00Z",
		workshopCompletedAt: null,
		issues: [
			{
				id: 11,
				code: "IS20260718_ZZ103C",
				serviceCategory: "Bodywork",
				issueType: {
					id: 3,
					name: "Rear bumper",
				},
				issueDescription: "Scratch on rear bumper",
				createdAt: "2026-07-18T09:00:00Z",
				status: "InProgress",
				allowedTransitions: ["Completed", "Cancelled"],
				outcome: null,
				unfixedReason: null,
				zendeskId: null,
				relatedCaseNo: null,
				handoverFlagged: false,
				handoverNote: null,
			},
		],
		jobs: [],
	},

	{
		id: 4450,
		code: "WO20260701_M301XY",
		vehicleId: 1403,
		plateNumber: "SMK3424D",
		status: "InWorkshop",
		allowedTransitions: ["CompletedByWorkshop", "Cancelled"],
		flowType: "Workshop",
		createdAt: "2026-06-28T09:00:00Z",
		lastUpdatedAt: "2026-07-05T12:00:00Z",
		destination: {
			type: "Workshop",
			workshopId: 12,
			workshopName: "Workshop ABC",
			address: "6 Ubi Ave #01-100 Singapore 432123",
		},
		appointmentStart: "2026-06-30T09:00:00Z",
		appointmentEnd: "2026-06-30T13:00:00Z",
		workshopEnteredAt: "2026-06-28T09:00:00Z",
		workshopCompletedAt: null,
		issues: [
			{
				id: 12,
				code: "IS20260625_QW881A",
				serviceCategory: "Maintenance",
				issueType: {
					id: 4,
					name: "Engine service",
				},
				issueDescription: "Scheduled engine servicing",
				createdAt: "2026-06-25T09:00:00Z",
				status: "InProgress",
				allowedTransitions: ["Completed", "Cancelled"],
				outcome: null,
				unfixedReason: null,
				zendeskId: null,
				relatedCaseNo: null,
				handoverFlagged: true,
				handoverNote: null,
			},
		],
		jobs: [],
	},

	// Vehicle 1401's second Workshop-flow work order — for testing both the
	// workshop-view and regular ops completion flows against the same data.
	{
		id: 4476,
		code: "WO20260827_JT44RS",
		vehicleId: 1401,
		plateNumber: "SMS1000Z",
		status: "InWorkshop",
		allowedTransitions: ["CompletedByWorkshop", "Cancelled"],
		flowType: "Workshop",
		createdAt: "2026-08-26T07:00:00Z",
		lastUpdatedAt: "2026-08-27T09:00:00Z",
		destination: {
			type: "Workshop",
			workshopId: 12,
			workshopName: "Workshop ABC",
			address: "6 Ubi Ave #01-100 Singapore 432123",
		},
		appointmentStart: "2026-08-27T01:00:00Z",
		appointmentEnd: "2026-08-27T05:00:00Z",
		workshopEnteredAt: "2026-08-27T01:12:00Z",
		workshopCompletedAt: null,
		issues: [
			{
				id: 13,
				code: "IS20260826_DR120A",
				serviceCategory: "Bodywork",
				issueType: {
					id: 1,
					name: "Front bumper",
				},
				issueDescription: "Scratched driver door",
				createdAt: "2026-08-26T08:00:00Z",
				status: "InProgress",
				allowedTransitions: ["Completed", "Cancelled"],
				outcome: null,
				unfixedReason: null,
				zendeskId: null,
				relatedCaseNo: null,
				handoverFlagged: false,
				handoverNote: null,
			},
			{
				id: 14,
				code: "IS20260826_DR120B",
				serviceCategory: "Maintenance",
				issueType: {
					id: 4,
					name: "Aircon",
				},
				issueDescription: "Aircon compressor needs a part on backorder",
				createdAt: "2026-08-26T08:10:00Z",
				status: "InProgress",
				allowedTransitions: ["Completed", "Cancelled"],
				outcome: null,
				unfixedReason: null,
				zendeskId: null,
				relatedCaseNo: null,
				handoverFlagged: false,
				handoverNote: null,
			},
		],
		jobs: [],
	},
	// Real UAT work order; its existing issues aren't mocked.
	{
		id: 43,
		code: "WO20261014_W97G3B",
		vehicleId: 20209,
		plateNumber: "",
		status: "Triage",
		allowedTransitions: ["InProgress", "InWorkshop", "Cancelled"],
		flowType: "Workshop",
		createdAt: "2026-10-14T00:00:00Z",
		lastUpdatedAt: "2026-10-14T00:00:00Z",
		destination: null,
		appointmentStart: null,
		appointmentEnd: null,
		workshopEnteredAt: null,
		workshopCompletedAt: null,
		issues: [],
		jobs: [],
	},
];
